// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"file-attachment"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M20 11V7L15 2H4V22H12M14 2V8H20","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M19 19V15.5C19 14.6716 18.3284 14 17.5 14C16.6716 14 16 14.6716 16 15.5V20C16 21.6569 17.3431 23 19 23C20.6569 23 22 21.6569 22 20V16.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FileAttachmentIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'file-attachment',
    ref,
    icon: element,
  },
));

FileAttachmentIcon.displayName = 'FileAttachmentIcon';

export default FileAttachmentIcon;
